import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, NgZone, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../shared.service';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';
import { AzurePersonRoles } from 'src/app/core/models/AzurePersonRoles';
import { AzurePerson } from 'src/app/core/models/AzurePerson';

@Component({
  standalone: false,
  selector: 'fdb-azure-person',
  templateUrl: './azure-person.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./azure-person.component.scss']
})
export class AzurePersonComponent implements OnInit, OnChanges {
  public UIControlTyp = UIControlTyp;
  public AzurePersonRoles = AzurePersonRoles;
  public SelectedAzurePersonId: number = 0;
  public DisplayName: string = '';

  /** Hiermit können Sie den UIControlTyp entscheiden => Default DropDownList */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  /** Hiermit definieren Sie von welchen Rolen Sie die User möchten
   * => Default ProjectTeamMember
   */
  @Input() roles: AzurePersonRoles = AzurePersonRoles.Any;
  // tslint:disable-next-line: no-input-rename
  @Input('values')
  get values() {
    const val = this.uiController === UIControlTyp.MultiSelectList ?
      this.AzurePersons.map(unit => Number(unit.id)) :
      Number(this.SelectedAzurePersonId || 0);
    return val;
  }
  set values(val: string | number | (string | number)[]) {
    if (Array.isArray(val)) {
      this.AzurePersons = (val as (string | number)[]).map(id => this.getObjectFromList(Number(id)));
      this.getRefreshSelectedValue();
    } else {
      this.SelectedAzurePersonId = this.normalizeId(val as string | number);
      this.AzurePerson = this.getObjectFromList(this.SelectedAzurePersonId);
    }

    this.scheduleSyncDisplayName();
  }
  @Output() valuesChange = new EventEmitter();
  @Output() objectChange = new EventEmitter();

  /** Enthält die ausgewählten Werte bei UIControlTyp.MultiSelectList */
  public AzurePersons: AzurePerson[] = [];
  /** Enthält die ausgewählten Wert bei UIControlTyp.DropDownList */
  public AzurePerson: AzurePerson;
  /** Enthält die Werte die angezeigt werden dürfen */
  public AzurePersonList: AzurePerson[] = [];
  /** Enthält die Originalliste mit allen Werten */
  private OriginalValues: AzurePerson[] = [];

  constructor(private modulService: SharedService, private cdr: ChangeDetectorRef, private ngZone: NgZone) {
  }

  ngOnInit() {
    this.initAzurePersonList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.uiController) {
      this.scheduleSyncDisplayName();
    }
  }

  initAzurePersonList() {
    const that = this;
    this.modulService.getAzurePerson(that.roles)
      .subscribe(apiResult => {
        that.ngZone.run(() => {
          if (!apiResult.isSuccessful) {
            that.modulService.showNotification(apiResult.message, 'error');
          }
          if (apiResult.payload) {
            that.OriginalValues = apiResult.payload;
            that.AzurePersonList = that.OriginalValues.filter(s => s.isActive === true);
            if (that.uiController === UIControlTyp.DropDownList) {
              that.AzurePersonList.unshift(new AzurePerson().getEmptyModel());
            }
            that.refreshSelectedValue();
            that.scheduleSyncDisplayName();
          }
        });
      },
        err => that.ngZone.run(() => that.modulService.showNotification(err, 'error')));
  }

  getName() {
    const find = this.getObjectFromList(Number(this.AzurePerson ? this.AzurePerson.id : this.SelectedAzurePersonId));
    if (find && find.name && find.name.trim().length > 0) {
      return find.id === 0 ? '-- Bitte pflegen --' : find.name;
    }
    return '';
  }

  filterAzurePersons(value: string) {
    this.AzurePersonList = this.OriginalValues
      .filter((s) => (s.name || '').toLowerCase().indexOf(value.toLowerCase()) !== -1 && s.isActive === true);
  }

  valueChanged(event?: number | (string | number)[]): void {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      if (Array.isArray(event)) {
        this.AzurePersons = event.map(id => this.getObjectFromList(Number(id)));
      }
      this.getRefreshSelectedValue();
    } else {
      this.SelectedAzurePersonId = this.normalizeId(event as number);
      this.AzurePerson = this.getObjectFromList(this.SelectedAzurePersonId);
    }

    this.valuesChange.emit(this.values);
    this.objectChange.emit(this.AzurePerson);
    this.scheduleSyncDisplayName();
  }

  getObjectFromList(id: number): AzurePerson {
    if (id === 0) { return new AzurePerson().getEmptyModel(); }
    const find = this.OriginalValues.find(unit => Number(unit.id) === id);
    return find ? find : new AzurePerson().setId(id);
  }
  getRefreshSelectedValue() {
    this.AzurePersons = this.AzurePersons
      .map(x => this.OriginalValues.find(y => Number(y.id) === Number(x.id)) || x)
      .filter(x => !!x);
  }

  private refreshSelectedValue() {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      this.getRefreshSelectedValue();
      this.scheduleSyncDisplayName();
      return;
    }

    const selectedId = Number(this.AzurePerson ? this.AzurePerson.id : this.SelectedAzurePersonId);
    this.AzurePerson = this.getObjectFromList(selectedId);
    this.SelectedAzurePersonId = selectedId;
    this.scheduleSyncDisplayName();
  }

  private normalizeId(id: string | number): number {
    const parsed = Number(id);
    return isNaN(parsed) ? 0 : parsed;
  }

  private syncDisplayName() {
    this.DisplayName = this.getName();
    this.cdr.markForCheck();
  }

  private scheduleSyncDisplayName() {
    setTimeout(() => this.syncDisplayName(), 0);
  }

}
